export const AppRoutes = {
  Root: "/",
  AzureAdSignin: "/azure-ad-signin",
};
